import { createServerFn } from "@tanstack/react-start";
import { siteContext } from "../server/site.server";
import { platformPageResponse } from "./page-response";
import { readPlatformHome } from "./home.server";
import { regularPlanShown } from "./plan-flag.server";

/** Drate's homepage in one story (?flow=) or the everyday one; null on a creator's site. */
export const loadPlatformHome = createServerFn({ method: "GET" })
  .validator((flow: unknown) => (typeof flow === "string" && flow.length <= 40 ? flow : null))
  .handler(async ({ data: flow, context }) => {
    const drate = await siteContext(context);
    if (!drate.creator) platformPageResponse(drate);
    return readPlatformHome(drate, flow, await regularPlanShown(drate));
  });
